import { CheckoutStyleTokens } from "@omni/ui/brand/checkout/checkout.tokens";

export const CheckoutStyles: CheckoutStyleTokens = {
    submitButton: {
        color: "primary"
    },
    secureFieldStyles: {
        lineHeight: "46px"
    }
};
